import Box from 'carbon-react/esm/components/box';
import Typography from 'carbon-react/esm/components/typography';
import React from 'react';
import { Link } from 'react-router-dom';
// import Button from 'carbon-react/esm/components/button/__next__';
import Button from 'carbon-react/esm/components/button/__next__';
import { useUserInfos } from '../hooks/useUserInfos';

const Unauthorized: React.FC = () => {
  const { hasRole, handleLogout } = useUserInfos();

  return (
    <Box
      height="600px"
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      gap={2}
    >
      <Typography variant="h1" mb={2}>
        Accès non autorisé
      </Typography>
      <Typography variant="h4" mb={2}>
        Vous n&apos;avez pas la permission d&apos;accéder à cette page.
      </Typography>
      {hasRole(['exploit']) ? (
        <Button
          onClick={handleLogout}
          // type="button"
          // variant="default"
          // variantType="primary"
          variantType="primary"
          size="large"
          p="0.8em 80px"
          mt={4}
        >
          Déconnexion
        </Button>
      ) : (
        <Link to="/">Retour à l&apos;accueil</Link>
      )}
    </Box>
  );
};

export default Unauthorized;
